import { useUnsavedGuard } from "@artists/devkit"
import type { Dispatch, ReactNode, SetStateAction } from "react"
import { createContext, useContext } from "react"
import { useTranslation } from "react-i18next"

type UnsavedCtsProps = Dispatch<SetStateAction<boolean>>

interface UnsavedProviderProps {
	children: ReactNode
}

const UnsavedContext = createContext({} as UnsavedCtsProps)

const UnsavedContextProvider = ({ children }: UnsavedProviderProps) => {
	const { t } = useTranslation("vote")

	const { setDirty } = useUnsavedGuard(
		t("warnings.leaveWithoutSubmitting.text"),
	)

	return (
		<UnsavedContext.Provider value={setDirty}>
			{children}
		</UnsavedContext.Provider>
	)
}

const useUnsavedWarning = () => useContext(UnsavedContext)

export { UnsavedContextProvider, useUnsavedWarning }
